/* eslint-disable */
import './objectExtensions';

const isEmpty = value => value === undefined || value === null || value === '';

export function email(value) {
  // Let's not start a debate on email regex. This is just for an example app!
  if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return !isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) && 'Wrong email';
  }
}

export function required(value) {
  if (isEmpty(value) || /^\s+$/.test(value)) {
    return 'Required';
  }
}

export function isBlankNullOrUndefined(value) {
  return value === '' || value === undefined || value === null || value === {};
}
